import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Eleicao } from 'src/app/models/eleicao.model';
import { Resultado } from 'src/app/models/resultado.model';
import { ResultadosEleicao } from 'src/app/models/resultadosEleicao.model';
import { ResultadosService } from 'src/app/services/resultados.service';
import { ComprovanteService } from 'src/app/services/comprovante.service';
import { VotoService } from 'src/app/services/voto.service';
import { __param } from 'tslib';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { ComprovantePlanilhaDTO } from 'src/app/models/comprovantePlanilhaDTO.model';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';



@Component({
  selector: 'app-table-resultado-parcial-eleicao',
  templateUrl: './table-resultado-parcial-eleicao.component.html',
  styleUrls: ['./table-resultado-parcial-eleicao.component.css']
})
export class TableResultadoParcialEleicaoComponent implements OnInit {

  public resultados: Resultado[] = [];
  public listaPorPlano:  Resultado[] = [];
  public resultadosEleicao: ResultadosEleicao;
  public token: any;
  public totalVotos: number;
  public listaPlanosFiltrada : string [] = [];
  public listaPlano : string [] =[];
  public comprovantesPlanilha : ComprovantePlanilhaDTO [] = [];
  public eleicao: Eleicao;
  public dataInicio: string;
  public dataFim: string;
  formGroup: FormGroup;
  
  @Input() eleicaoId: number;
  logo: any;
  offset: number;
  
  constructor(
    protected resultadosService: ResultadosService,
    protected votoService: VotoService,
    protected formBuilder: FormBuilder,
    protected comprovanteService: ComprovanteService,
    protected eleicaoService: EleicaoService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    protected router: Router,
    public utils: Utils
    ) {}
    
  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    this.getComprovanteVotantes(this.eleicaoId,this.token);
    this.getResultadosParciais(this.eleicaoId, this.dataInicio, this.dataFim, this.token);
    this.getEleicao(this.eleicaoId, this.token);
    this.formGroup = new FormGroup({
      dataInicio: new FormControl(),
      dataFim: new FormControl()
    })

    this.formGroup = this.formBuilder.group({
      dataInicio: ['', Validators.required],
      dataFim: ['', Validators.required]
    });
    // var logoRaw = sessionStorage.getItem("logoeleicao");
    // this.logo = logoRaw
  }

  async getResultadosParciais(idEleicao: number, dataInicio:string, dataFim:string, token: any) {
    
    let intervaloDatas = [dataInicio, dataFim];

    this.resultadosService.getAllParcialByIdEleicao(idEleicao, intervaloDatas, token).then((resultados: ResultadosEleicao) => {
      this.resultadosEleicao = resultados;
      this.resultados = this.resultadosEleicao.resultados.sort(sortBy('candidatoCargo', '-numVotos'));
      const resultadosSemBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome != 'Nulo' && par.candidatoNome != 'Branco' );
      const resultadosBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome == 'Nulo' || par.candidatoNome == 'Branco' );
      this.resultados = resultadosSemBrancosNulos.concat(resultadosBrancosNulos);
      this.criarListadePlanos(this.resultados);
      console.log(this.resultadosEleicao)
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }

  criarListadePlanos(lista:Resultado[]){
    lista.forEach(l => {
      this.listaPlano.push(l.plano);
      if(l.plano == '' && l.numVotos == 0){
        this.listaPlano.pop();
      }
    });
    this.listaPlanosFiltrada = this.listaPlano.filter(this.onlyUnique); // [GERAL, '', plano1, plano2, ...]
    console.log(this.listaPlanosFiltrada)
    this.spinner.hide();
  }
  somaTotalPorPlano(param:any){
    var sum = this.resultados.filter(p=> p.plano == param).reduce((sum, element) => { return sum + element.numVotos; }, 0);
     //console.log(sum);
    return sum;
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  exportParaExcel(){
    let dadosResultado = this.resultados
    this.utils.exportParaExcel(dadosResultado,this.resultadosEleicao.titulo,this.listaPlanosFiltrada)
  }

  getComprovanteVotantes(idEleicao: number, token: any) {
    this.comprovanteService.getComprovantesPorIdEleicao(idEleicao, token).then((res:any) => {
      this.comprovantesPlanilha = res;
      //console.log(res);
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }
  exportVotantesParaExcel(){
    this.utils.exportComprovantesParaExcel(this.comprovantesPlanilha,this.resultadosEleicao.titulo,this.listaPlanosFiltrada)
  }

  public onSubmit(value){
    this.dataInicio = this.formGroup.get('dataInicio').value;
    this.dataFim = this.formGroup.get('dataFim').value;
    let intervaloDatas = [this.dataInicio, this.dataFim];

    if (!this.formGroup.valid || !this.dataInicio || !this.dataFim 
      || !this.validarDatas(this.dataInicio, this.dataFim)) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Os campos de Data inicio e Data fim devem ser preenchidos entre a data de inicio e fim da eleição!" })
    }

    this.resultadosService.getAllParcialByIdEleicao(this.eleicao.id, intervaloDatas, this.token).then((resultados: ResultadosEleicao) => {
      this.resultadosEleicao = resultados;
      this.resultados = this.resultadosEleicao.resultados.sort(sortBy('candidatoCargo', '-numVotos'));
      const resultadosSemBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome != 'Nulo' && par.candidatoNome != 'Branco' );
      const resultadosBrancosNulos = JSON.parse(JSON.stringify(this.resultados)).
        filter( par => par.candidatoNome == 'Nulo' || par.candidatoNome == 'Branco' );
      this.resultados = resultadosSemBrancosNulos.concat(resultadosBrancosNulos);
      this.criarListadePlanos(this.resultados);
      console.log(this.resultadosEleicao)
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }

  getEleicao(idEleicao: number, token: any) {
    this.eleicaoService.getById(idEleicao, token).then((eleicao: Eleicao) => {
      this.eleicao = eleicao
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }

  public validarDatas(dataInicio?: string, dataFim?: string){
    let dataInicioEleicao = new Date(this.eleicao.dataHoraInicio);
    let dataFimEleicao = new Date(this.eleicao.dataHoraFim);
    let dataInicioIntervalo = new Date(dataInicio + "T23:59:59-03:00");
    let dataFimIntervalo = new Date (dataFim + "T00:00:00-03:00");
    
    if((dataInicio == dataFim) &&
        dataInicioIntervalo >= dataInicioEleicao &&
        dataFimIntervalo <= dataFimEleicao){
      return true;
    }else if(dataInicioIntervalo < dataInicioEleicao || 
       dataInicioIntervalo > dataFimEleicao || 
       dataFimIntervalo > dataFimEleicao ||
       dataFimIntervalo < dataInicioEleicao){
        return false;
    }else{
      return true;
    }
  }

  isPlanoMatching(cargoPlano: string, plano: string): boolean {
    if (plano === 'GERAL' || !plano) {
      return true; // Exibe se o plano for "GERAL" ou não houver plano
    }
    if (!cargoPlano) {
      return false; // Não exibe se não houver cargoPlano
    }
    const planos = cargoPlano.split(','); // Divide os planos separados por vírgula
    return planos.includes(plano); // Verifica se o plano está presente no array
  }

}
